import React from 'react';
import styled from 'styled-components';
import CartItem, { SKU_TYPE } from '../../../domain/entities/Cart/CartItem';
import CONSTANTS from '../../../constants/Constants';

interface ICartItemImage {
  item: CartItem;
  baseUrl: string;
}

interface IStateCartImage {
  imageSourceIndex: number;
  imageSourceUrl: string;
}

const CartItemImageStyled = styled.img`
  object-fit: contain;
  max-width: 100%;
`;

class CartItemImage extends React.Component<ICartItemImage, IStateCartImage> {

  constructor(props: ICartItemImage) {
    super(props);
    this.state = {
      imageSourceIndex: 0,
      imageSourceUrl: props.item.images?.[0],
    };
  }

  private addDomainToUrl(url: string): string {
    return url.includes(CONSTANTS.HTTP) || !url ? url : `${this.props.baseUrl}${url}`;
  }

  private onError = (): void => {
    const nextImageSourceIndex = this.state.imageSourceIndex + 1;
    if (nextImageSourceIndex < this.props.item.images.length) {
      const imagePath = this.props.item.images[nextImageSourceIndex];
      const imagePathWithDomain = imagePath?.length ? this.addDomainToUrl(imagePath) : imagePath;

      this.setState({
        imageSourceIndex: nextImageSourceIndex,
        imageSourceUrl: imagePathWithDomain,
      });
    }
  };

  render(): JSX.Element {
    const { item: { shadename, productRgnName, skuType, images } } = this.props;
    const isGiftWrapImg = skuType === SKU_TYPE.GiftWrap;
    const imgAlt = shadename && shadename !== productRgnName ? `${shadename} - ${productRgnName}` : productRgnName;
    const cleanImgAlt = imgAlt?.replace(/<\/?[^>]+(>|$)/g, ''); // Removed HTML tags
    const imageSrc = isGiftWrapImg ? images?.[0] : this.state.imageSourceUrl;

    return (
      <CartItemImageStyled
        src={imageSrc}
        width="100"
        height="100"
        alt={cleanImgAlt || 'Product Image'}
        data-test-id="dp_product_image"
        onError={this.onError}
      />
    );
  }
}

export default CartItemImage;
